import styled from "styled-components";
import { colors, zIndex } from "../../Global.style";

export const ModalBox = styled.div`
    position: fixed;
    left: 0;
    width: 100vw;
    top: 0;
    height: 100vh;
    z-index: ${zIndex.modal};
    background: rgb(13,13,13,0.7);
    white-space: normal;
    .modal_content_box{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 440px;
        background: #252736;
        color: ${colors.baseColor};
        box-sizing: border-box;
        border-radius: 16px;
        padding: 32px;
        .close{
            position: absolute;
            right: 44px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            .closeIcon{
                width: 15px;
                height: 15px;
                cursor:pointer;
                vertical-align: initial;
            }
        }
    }
    .modal-title{
        position: relative;
        font-size: 26px;
        font-weight: 400;
        margin: 0 0 24px;
    }
`;
